<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>出入金统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">下单开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.startDate" type="date" size="small" format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">下单结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.endDate" type="date" size="small" format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">订单号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderNo" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">用户ID:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
<!--              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>-->
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="table" class="full-height display-col">
        <div class="tips">
          <span class="tip-item">订单合计 {{addThousandSeparator(form.totalIncomeFee)}}元</span>
          <span class="tip-item">采购利润总计 {{addThousandSeparator(form.totalNetFee)}}元</span>
        </div>
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
                  height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column width="100" prop="createTime" align="center" label="下单日期">
          </el-table-column>
          <el-table-column prop="userId" align="center" label="ID">
            <template v-slot="{row}">
              <el-tooltip placement="top" effect="light">
                <template slot="content">
                  <div class="toolTipClass">{{ row.userId }}</div>
                </template>
                <div class="ellipsis-clamp">{{ row.userId }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="userName" align="center" label="客户名">
          </el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单编号">
            <template v-slot="{row}">
              <el-tooltip placement="top" effect="light">
                <template slot="content">
                  <div class="toolTipClass">{{ simplifyRanges(row.orderNo) }}</div>
                </template>
                <div class="ellipsis-clamp">{{ simplifyRanges(row.orderNo) }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="goodsFee" align="center" label="商品费">
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.goodsFee) }}
            </template>
          </el-table-column>
          <el-table-column prop="inlandFreight" align="center" label="国内运费">
          </el-table-column>
          <el-table-column prop="agentServiceFee" align="center" label="代购手续费((商品费+国内运费)*6%)"></el-table-column>
          <el-table-column prop="purchaseCost" align="center" label="采购金额">
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.purchaseCost) }}
            </template>
          </el-table-column>
          <el-table-column prop="inspectionFee" align="center" label="采购利润">
          </el-table-column>
          <el-table-column prop="total" align="center" label="订单合计">
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.total) }}
            </template>
          </el-table-column>
          <el-table-column prop="currencyAmount" align="center" label="订单合计 + 币种">
            <template v-slot="{row}">
              <div style="white-space: pre-wrap;color: #ffa621;">{{ formatSettlementAmount(row) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="total-xxx" align="center" label="是否汇款">
          </el-table-column>
          <el-table-column prop="labelFee-xxx" align="center" label="备注">
          </el-table-column>
          <el-table-column prop="currencyRate" align="center" label="汇率">
            <template v-slot="{row}">
              {{ formatSettlementRate(row) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  name:'orderAmountSummary',
  data () {
    return {
      queryInfo: {
        startDate: '',
        endDate: '',
        pageSize: 10,
        pageNum: 1,
        userName:"",
        orderNo:""
      },
      recordList: [],
      total: 0,
      form: {},
    }
  },
  methods: {
    simplifyRanges(input) {
      return input.split(',') // 按逗号拆分
          .map(group => {
            const numbers = group.split('+').map(Number).sort((a, b) => a - b); // 拆分并排序
            let result = [];
            let start = numbers[0], end = start;

            for (let i = 1; i < numbers.length; i++) {
              if (numbers[i] === end + 1) {
                // 继续扩展区间
                end = numbers[i];
              } else {
                // 终止当前区间
                result.push(start === end ? `${start}` : `${start}~${end}`);
                start = end = numbers[i];
              }
            }
            // 处理最后一个区间
            result.push(start === end ? `${start}` : `${start}~${end}`);
            return result.join(','); // +
          })
          .join(','); // +
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    async exportAction () {
      this.$http({
        url: '/financial/exportOrderIncome',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '订单收入统计列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getTool();
    },
    async getrecordList () {
      const { data: res } = await this.$http.get('/financial/queryOrderIncomeSummary', { params: this.queryInfo });
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNum = 1
      this.queryInfo.orderNo = ''
      this.queryInfo.userName = ''
      this.queryInfo.endDate= ''
      this.queryInfo.startDate = ''
    },
    async getTool () {
      const params = {
        startDate: this.queryInfo.startDate,
        endDate: this.queryInfo.endDate,
        userName:this.queryInfo.userName,
        orderNo:this.queryInfo.orderNo
      }
      const { data: res } = await this.$http.get('/financial/queryOrderIncomeSummaryHeader',{params});
      this.form = res.data
    }
  },
  activated () {
    this.getrecordList();
  },
  created () {
    this.getrecordList();
    this.getTool();
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.tips {
  margin: 15px 0;
  text-align: right;
}
.tip-item{
  margin-left: 30px;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.toolTipClass{
  width: auto;
  max-width: 200px;
}
</style>
